import React, { Component } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";
import AnalyticsHeader from "visual-components/analyticsDashboard/analytics-header";
import SocialActionsTooltip from "visual-components/analyticsDashboard/tooltip/SocialActionsTooltip";
import GraphEmptyState from "visual-components/util/graphs/empty-state";
import LabeledBarChart from "./LabeledBarChart";

export default class SocialContributionCard extends Component {
  render() {
    const { data, started } = this.props;

    const hasData = data && data.some((brand) => brand.entries > 0);

    return (
      <Card sx={{ height: 500 }}>
        <CardHeader
          title={
            <AnalyticsHeader
              title="Social Contribution"
              tooltipText="Social Contributions shows a simple breakdown of the extra social engagement driven by each brand. This tracks how many people, per brand, came directly to the landing page from that brand's promotion, entered their email, and then clicked any post social action option (like share, like, or follow) in the popup that appeared afterward."
            />
          }
        />
        <CardContent>
          {hasData ? (
            <LabeledBarChart
              data={data}
              enabled={started}
              labelField="accountname"
              valueField="entries"
              tooltip={(params) => <SocialActionsTooltip {...params} />}
            />
          ) : (
            <GraphEmptyState
              text={
                "Social Actions is a powerful feature reserved for Essential and Premium DojoMojo users."
              }
              learnMore={
                "https://help.dojomojo.com/hc/en-us/articles/230426167-Add-Partner-Social-Actions-"
              }
              bigText
            />
          )}
        </CardContent>
      </Card>
    );
  }
}
